import React from "react";
import {
  Facebook,
  Instagram,
  Line,
  Twitter,
  Whatsapp,
  Youtube,
} from "../icons";
import { useMediaQuery } from "react-responsive";

const imageBasePath =
  window.location.protocol + "//" + window.location.host + "/";

export default function Footer() {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const imageBasePath =
    window.location.protocol + "//" + window.location.host + "/";

  return (
    <div className="footer">
      <div className="sec-1">
        <img
          className="footer-logo"
          src={imageBasePath + "logo.png"}
          alt={imageBasePath + "logo.png"}
        />
        <span className="follow-text">FOLLOW US</span>
        <div className="social">
          <Facebook
            onClick={() =>
              window.open("https://www.facebook.com/btcjapanofficial", "_blank")
            }
          />
          <Instagram
            onClick={() =>
              window.open(
                "https://instagram.com/btcjapanofficial?igshid=OGQ5ZDc2ODk2ZA==",
                "_blank"
              )
            }
          />
          <Youtube
            onClick={() =>
              window.open("https://www.youtube.com/@BTCJAPAN", "_blank")
            }
          />
          <Twitter
            onClick={() =>
              window.open("http://www.tiktok.com/@btcjapan", "_blank")
            }
          />
        </div>
      </div>

      <FooterText />
      {!isMobile && <FooterLinks />}
      {!isMobile && (
        <div className="sec-4">
          <button
            onClick={() => {
              window.open("https://line.me/R/ti/p/@154cuxhs", "_blank");
            }}
          >
            <Line />
            Line us.
          </button>
          <button
            onClick={() => {
              window.open("https://wa.me/818065668000", "_blank");
            }}
          >
            <Whatsapp /> WhatsApp us.
          </button>
        </div>
      )}
      {isMobile && (
        <div style={{ display: "flex", flexDirection: "row", marginLeft: -70 }}>
          <div
            style={{ display: "flex" }}
            onClick={() => {
              window.open("https://line.me/R/ti/p/@154cuxhs", "_blank");
            }}
          >
            <img
              className="footer-social-icons"
              src={imageBasePath + "line-icon.png"}
              style={{ marginLeft: 85, verticalAlign: "middle" }}
              alt={imageBasePath + "line-icon.png"}
            />
            <span style={{ marginLeft: 10 }}> Line us. </span>
          </div>
          <div
            style={{ display: "flex" }}
            onClick={() => {
              window.open("https://wa.me/818065668000", "_blank");
            }}
          >
            <img
              className="footer-social-icons"
              src={imageBasePath + "whatsapp-icon.png"}
              style={{ marginLeft: 20, verticalAlign: "middle" }}
              alt={imageBasePath + "whatsapp-icon.png"}
            />
            <span style={{ marginLeft: 10 }}> Whatsapp us. </span>
          </div>
        </div>
      )}
    </div>
  );
}

const FooterText = () => {
  return (
    <div>
      <div className="footer-headings">
        CONTACT US
        <img
          className="footer-headings-img"
          src={imageBasePath + "footer-underline.png"}
          alt={imageBasePath + "footer-underline.png"}
        />
      </div>
      <div className="text-2">
        <br />
        <img
          className="footer-icons"
          src={imageBasePath + "location.png"}
          alt={imageBasePath + "location.png"}
        />{" "}
        AICHI PREFECTURE KASUGAI
        <br />
        <img
          className="footer-icons"
          src={imageBasePath + "location.png"}
          style={{ opacity: 0 }}
          alt={imageBasePath + "location.png"}
        />{" "}
        CITY FUJIYAMADAI 9-7-3
        <br />
        <img
          className="footer-icons"
          src={imageBasePath + "location.png"}
          style={{ opacity: 0 }}
          alt={imageBasePath + "location.png"}
        />{" "}
        SANGARDEN KOZOJI 103
        <br />
        <img
          className="footer-icons"
          src={imageBasePath + "phone.png"}
          alt={imageBasePath + "phone.png"}
        />{" "}
        TEL : +81 80 2305 8000
        <br />
        <img
          className="footer-icons"
          src={imageBasePath + "fax.png"}
          alt={imageBasePath + "fax.png"}
        />{" "}
        FAX : +81-568-64-8080
        <br />
        <img
          className="footer-icons"
          src={imageBasePath + "email.png"}
          alt={imageBasePath + "email.png"}
        />{" "}
        E-mail : info@btcjapan.net
        <br />
      </div>
    </div>
  );
};

const FooterLinks = () => {
  return (
    <div style={{ marginTop: 27 }}>
      <div className="footer-headings">
        RESOURCES
        <img
          className="footer-headings-resource-img"
          src={imageBasePath + "footer-underline.png"}
          alt={imageBasePath + "footer-underline.png"}
        />
      </div>
      <div className="text">
        <br />
        About us
        <br />
        Contact us
        <br />
        <a
          style={{ textDecoration: "none", color: "white" }}
          href="/privacy-policy"
        >
          Privacy policy
        </a>
        <br />
        <a
          style={{ textDecoration: "none", color: "white" }}
          href="terms-conditions"
        >
          {" "}
          Terms and Condition{" "}
        </a>
        <br />
        Newsletter
        <br />
        How to use BTC
        <br />
        <br />
      </div>
    </div>
  );
};
